import * as React from "react"

import { Container } from "react-bootstrap"

import { Header } from "./Header"

import styled from "styled-components";
import theme from "../Theme";

import "@fontsource/nunito-sans/200.css"

const Main = styled.main`
    font-family: ${theme.bodyFont.fontFamily};
    font-weight: ${theme.bodyFont.fontWeight};
    
    p {
        font-size: 20px;
        color: #444444;
        text-align: justify;
    }

    h1 {
        text-transform: uppercase;
        font-weight: 100;
        color: ${theme.highlight};
    }

    h2 {
        text-transform: uppercase;
        font-weight: 100;
        font-size: 28px;
        color: ${theme.dark};
        margin-top: 20px;
        margin-bottom: 32px;
    }

    h3 {
        text-transform: uppercase;
        font-weight: 100;
        font-size: 20px;
        color: ${theme.dark}
    }

    a {
        color: ${theme.dark};
        text-transform: uppercase;
    }
`;

export const Layout = props => (
    <Main>
        <title>{props.title}</title>
        <Header />
        <Container>
            {props.children}
        </Container>
    </Main>
);
